import { render, staticRenderFns } from "./NonMedicalQualCard.vue?vue&type=template&id=edb51a46"
import script from "./NonMedicalQualCard.vue?vue&type=script&lang=js"
export * from "./NonMedicalQualCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports